module.exports = __webpack_public_path__ + "img/0Q3A6963_L_BlackMatted.51f83f74.jpg";